import template from '../ui/templates/modal/share-email.hbs';

class ModalShareEmail {
  constructor (opts) {
    const that = this;

    this.opts = $.extend(
      {
        userId: INKIVE.C.USER.id,
        userName: Base64.decode(INKIVE.C.USER.nickname),

        baseUrl: INKIVE.C.BASE_URL,
        staticUrl: INKIVE.C.STATIC_URL
      },
      opts
    );

    this.$wrapper = $(
      this.opts.wrapper
        ? $(this.opts.wrapper)
        : $('<div class="tool-content"></div>')
    );

    that.$wrapper.append(
      template({
        thumb: INKIVE.C.BOOK.thumb,
        book_name: Base64.decode(INKIVE.C.BOOK.name),
        book_description: Base64.decode(INKIVE.C.BOOK.description).trimToLength(
          100
        ),
        user_name: that.opts.userName
      })
    );
  }

  getFormHtml () {
    return this.$wrapper;
  }

  saveForm (callback) {
    callback = callback || $.noop;

    const url = INKIVE.C.BASE_URL + 'share/sendemail/' + INKIVE.C.BOOK.id;
    const form = this.$wrapper.parents('form');
    const form_data = form.serialize();

    $.post(
      url,
      form_data,
      function (data) {
        const recipient = INKIVE.Helpers.getFormValue(form, 'share_email');
        let viewerProjectUrl =
          INKIVE.C.BASE_URL + 'design/?id=' + INKIVE.C.BOOK.id;
        viewerProjectUrl = encodeURI(viewerProjectUrl);
        window.location.href =
          'mailto:' + recipient + '?body=' + viewerProjectUrl;

        data.success && callback(true);
      },
      'json'
    ).fail(function () {
      callback(false);
    });

    callback(false);
  }
}

module.exports = ModalShareEmail;
